import { render } from "./PaymentsDynamic.vue?vue&type=template&id=f120dfc2"
import script from "./PaymentsDynamic.vue?vue&type=script&lang=js"
export * from "./PaymentsDynamic.vue?vue&type=script&lang=js"

import "./PaymentsDynamic.vue?vue&type=style&index=0&id=f120dfc2&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__